import { Layout } from 'antd'
import React from 'react'
import HomePage from '../../components/Consultant/HomePage'

const ConsultantHomePage = () => {
    return (
       <Layout>
           <Layout.Content>
               <HomePage/>
           </Layout.Content>
       </Layout>
    )
}

export default ConsultantHomePage
